import debounce from 'lodash/debounce';
import { validateCreationForm } from '../helpers';
import has from 'lodash/has';
import { trackMultiInputAdd } from 'src/client/js/analytics/category/product';

const DEFAULT_DRAWER_KEY = 'names';

export const drawerKey = (props) => props.drawer.drawerKey || DEFAULT_DRAWER_KEY;

const handleValidationErrors = ({ names }, props) => errors =>  {
  // TODO workout correct validation errors once hooked up to muse
  if (!has(errors, 'names.error')) {
    props.setErrors({});
    props.setFieldValue('names', names);
    props.setAdditionalItem('');
  }
};

const debouncedValidation = debounce(
  (values, props, config) => validateCreationForm(values, props, config)
    .catch(handleValidationErrors(values, props)),
  500
);

export const mapCustomistaionToItems = (props) => {
  return props.productCustomisation[drawerKey(props)] || [];
};

export const handleItemChange = (props) => (itemsIndex, value) => {
  const items = props.values[drawerKey(props)].concat() || [];
  let newItems = [];
  if (!value) {
    newItems = items.filter((item, index) => itemsIndex !== index);
    debouncedValidation({ items: newItems }, props, { raw: true });
  } else {
    newItems = items.map((item, index) => (itemsIndex === index ? value : item));
    debouncedValidation({ items: newItems }, props, { raw: true });
  }

  props.setFieldValue(drawerKey(props), newItems);
};

export const addItem = (props) => () => {
  if (props.additionalItem !== '') {
    trackMultiInputAdd();
    const items = props.values[drawerKey(props)].concat() || [];
    const newItems = items.concat(props.additionalItem);
    let newItemsObject = {};
    newItemsObject[drawerKey(props)] = newItems;
    validateCreationForm(newItemsObject, props, { raw: true })
      .then(() => {
        props.setAdditionalItem('');
        props.setFieldValue(drawerKey(props), newItems);
      })
      .catch(handleValidationErrors(newItemsObject, props));
  }
};
